import { Form, Modal, Button, Input, Row, Col } from 'antd'
import React, { useState } from 'react'
import { UploadOutlined, UserAddOutlined  } from '@ant-design/icons';
import { v4 as uuid } from 'uuid';

export default function AddDemandConditions({showModel, setShowModel, setConditionItems, conditionItems}) {
    const [loading, setLoading] = useState(false)
    const onFinish=(values)=>{
        let newValues ={...values, id:uuid()}
        setConditionItems([...conditionItems, newValues])
        console.log("condition values", values);

    }
    const onFinishFailed=()=>{

    }
  return (
    <>
    <Modal
    visible={showModel}
    title="Add Conditions"
   footer={null}
   width={1000}
   onCancel={()=>setShowModel(false)}
    >
         <Form
               labelCol={{ span: 8 }}
               wrapperCol={{ span: 16 }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0">
                 <Row>
          <Col span={12}>
          <Form.Item
              label="Heading In English"
              name="headingEnglish"
              hasFeedback
              
              rules={[
                {
                  required: true,
                  message: "Heading in English",
                  
                },
                {
                  min:4,
                  message:"Minimum enter 4 characters"
                }
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Condition in English"
              name="conditionEnglish"
              hasFeedback
              
              rules={[
                {
                  required: true,
                  message: "Please Add Condition"
                  
                },
              ]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
        
            
           
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" loading={loading} htmlType="submit" icon={<UserAddOutlined />} style={{marginRight:'5px'}}>
          Add Condition
        </Button> 
        </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item
              label="Heading In Arabic"
              name="headingArabic"
              hasFeedback
              
              rules={[
                {
                  required: true,
                  message: "Heading in Arabic",
                  
                },
                {
                  min:4,
                  message:"Minimum enter 4 characters"
                }
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Condition in Arabic"
              name="conditionArabic"
              hasFeedback
              
              rules={[
                {
                  required: true,
                  message: "Please Add Condition"
                  
                },
              ]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
        
            
           
         
          </Col>
          </Row>
                    </Form> 
    </Modal>
    </>
  )
}
